import { http } from "../config.api.js"
// 人员请假 API_PeopleLeave
// "@/api/api.js"

//人员请假申请列表
export const personLeaveApplyList = (pageInfo, params) => {return http.get("/personLeaveManagement/personLeaveApplyList/" + pageInfo, { urlParams: params }).then(res => res.data);};
//历次请假情况查询列表
export const personLeaveSituation = (pageInfo, params) => { return http.get("/personLeaveManagement/personLeaveSituation/" + pageInfo, { urlParams: params }).then(res => res.data); };
//人员请假申请详情
export const personLeaveApplyDetail = (params) => { return http.get("/personLeaveManagement", { urlParams: params }).then(res => res.data); };
//项目选择
export const personLeaveProjects = (pageInfo, params) => { return http.get("/personLeaveManagement/personLeaveProjects/" + pageInfo, { urlParams: params }).then(res => res.data); };
//请假人员选择
export const personLeavePeople = (params) => { return http.get("/personLeaveManagement/personLeavePeople" , { urlParams: params }).then(res => res.data); };
//工作岗位选择（已改为写死）
//export const personLeaveWorkName = (params) => { return http.get("/personLeaveManagement/personLeaveWorkName" , { urlParams: params }).then(res => res.data); };
//判断请假时间
export const personLeaveDatePart = (params) => { return http.get("/personLeaveManagement/personLeaveDatePart" , { urlParams: params }).then(res => res.data); };
//删除
export const personLeaveDelete = (params) => { return http.delete("/personLeaveManagement/delete" , { urlParams: params }).then(res => res.data); };
//保存和提交
export const saveOrSubmitPersonLeave = (params) => { return http.post("/personLeaveManagement/saveOrSubmitPersonLeave" ,params).then(res => res.data); };
//提交盖章
export const personLeaveSubmit = (params) => { return http.post("/personLeaveManagement/personLeaveSubmit" ,params).then(res => res.data); };
//撤回
export const backPersonLeave = (params) => { return http.get("/personLeaveManagement/backPersonLeave" ,{ urlParams: params }).then(res => res.data); };
//审批人员选择
export const personLeaveAuditors = (params) => { return http.get("/personLeaveManagement/personLeaveAuditors" ,{ urlParams: params }).then(res => res.data); };
//人员请假审批列表
export const personLeaveManagmentSP = (pageInfo, params) => { return http.get("/personLeaveManagement/personLeaveManagmentSP/" + pageInfo, { urlParams: params }).then(res => res.data); };
//人员请假审批保存
export const update = (params) => { return http.post("/personLeaveManagement/update" ,params).then(res => res.data); };
//初审/审核通过盖章
export const seal = (params) => { return http.post("/personLeaveManagement/seal" ,params).then(res => res.data); };
//初审盖章保存回调
export const personLeaveSPFirst = (params) => { return http.post("/personLeaveManagement/personLeaveSPFirst" ,params).then(res => res.data); };
//审核盖章保存回调
export const personLeaveSPFinal = (params) => { return http.post("/personLeaveManagement/personLeaveSPFinal" ,params).then(res => res.data); };
//审批不同意
export const personLeaveSPFail = (params) => { return http.post("/personLeaveManagement/personLeaveSPFail" ,params).then(res => res.data); };
function parseUrl(url) {
    return encodeURI(encodeURI(JSON.stringify(url)));
}



// WEBPACK FOOTER //
// ./src/api/project/api_personLeave.js